define('datakit/util/getobject',['require','exports','module','backbone.radio','backbone'],function(require, exports, module){
  var Radio = require('backbone.radio');
  var Backbone = require('backbone');
  var getobject = {};

  // Split strings on dot, but only if dot isn't preceded by a backslash. Since
  // JavaScript doesn't support lookbehinds, use a placeholder for "\.", split
  // on dot, then replace the placeholder character with a dot.
  function getParts(str) {
    return str.replace(/\\\./g, '\uffff').split('.').map(function(s) {
      return s.replace(/\uffff/g, '.');
    });
  }

  function getDataKitModel() {
    return Radio.request('models', 'DataKit.Model') || Backbone.Model.extend({});
  }

  getobject.getParts = getParts;

  // Get the value of a deeply-nested property exist in an object.
  getobject.get = function(obj, parts, create) {
    var DataKitModel = getDataKitModel();
    if (typeof parts === 'string') {
      parts = getParts(parts);
    }

    var part, isModel = (obj instanceof Backbone.Model);
    var isDataKitModel = (obj instanceof DataKitModel)
    var isFirst = true, isLast;
    while (typeof obj === 'object' && obj && parts.length) {
      isLast = parts.length == 1;
      if (!isFirst && isDataKitModel) {
        // is the model is a datakit model
        // then we want to defer the dot-notation
        // to it rather than determining that here
        return obj.get(parts.join('.'));
      }
      part = parts.shift();
      if (!(isModel ? obj.has(part) : (part in obj)) && create) {
        isModel ? obj.set(part, {}) : obj[part] = {};
      }
      obj            = isModel ? obj.get(part) : obj[part];
      isModel        = (obj instanceof Backbone.Model);
      isDataKitModel = (obj instanceof DataKitModel);
      isFirst = false;
    }

    return obj;
  };

  // Set a deeply-nested property in an object, creating intermediary objects
  // as we go.
  getobject.set = function(obj, parts, value) {
    parts = getParts(parts);

    var prop = parts.pop(), isModel = false;
    obj = getobject.get(obj, parts, true);
    isModel = (obj instanceof Backbone.Model);
    if (obj && typeof obj === 'object') {
      return isModel ? obj.set(prop, value).get(prop) : (obj[prop] = value);
    }
  };

  // Does a deeply-nested property exist in an object?
  getobject.exists = function(obj, parts) {
    parts = getParts(parts);

    var prop = parts.pop(), isModel = false;
    obj = getobject.get(obj, parts);
    isModel = (obj instanceof Backbone.Model);
    return typeof obj === 'object' && obj && (isModel ? obj.has(prop) : (prop in obj));
  };

  module.exports = getobject;
});

